import PropTypes from 'prop-types';

import './rotatingLines.css';

function RotatingLines({ width, height, color, strokeWidth, visible = true }) {
  return (
    visible === true && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width={width}
        height={height}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        data-testid="rotating-lines-svg"
        aria-label="loading"
        aria-busy="true"
        role="progressbar"
        className="rotating-lines"
      >
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.17}
          transform="rotate(0, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.25}
          transform="rotate(30, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.33}
          transform="rotate(60, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.42}
          transform="rotate(90, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.5}
          transform="rotate(120, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.58}
          transform="rotate(150, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.66}
          transform="rotate(180, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.75}
          transform="rotate(210, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.83}
          transform="rotate(240, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          transform="rotate(270, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.92}
          transform="rotate(300, 24, 24)"
        ></polyline>
        <polyline
          points="24,12 24,4"
          strokeOpacity={0.08}
          transform="rotate(330, 24, 24)"
        ></polyline>
      </svg>
    )
  );
}

export default RotatingLines;

RotatingLines.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  visible: PropTypes.bool,
};
